export default __webpack_public_path__ + "static/media/4-3.6d7ff05e.mp3";